import { render, staticRenderFns } from "./ele2.vue?vue&type=template&id=902fa1aa&scoped=true"
import script from "./ele2.vue?vue&type=script&lang=js"
export * from "./ele2.vue?vue&type=script&lang=js"
import style0 from "./ele2.vue?vue&type=style&index=0&id=902fa1aa&prod&lang=scss"
import style1 from "./ele2.vue?vue&type=style&index=1&id=902fa1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902fa1aa",
  null
  
)

export default component.exports